module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getNurseConfirmList($event)
      }
    },
    model: {
      value: (_vm.filters.confirmInboundFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "confirmInboundFilter", $$v)
      },
      expression: "filters.confirmInboundFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getNurseConfirmList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseToConfirm', 'toConfirm.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.confirmInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "inboundNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.productName) + "\n                        "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.createDate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor === 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmInboundItem(scope.row.inboundNo, 'self', true)
            }
          }
        }, [_vm._v("Confirm\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor === 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmInboundItem(scope.row.inboundNo, 'warehouse', true)
            }
          }
        }, [_vm._v("\n                            Confirm\n                        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showCancelInbound(scope.row.inboundNo)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.confirmInboundTotal
    },
    on: {
      "current-change": _vm.changeConfirmInboundPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getReportList($event)
      }
    },
    model: {
      value: (_vm.filters.reportFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportFilter", $$v)
      },
      expression: "filters.reportFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getReportList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getReportList
    },
    model: {
      value: (_vm.filters.reportStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportStatus", $$v)
      },
      expression: "filters.reportStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseReported', 'report.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " (" + _vm._s(scope.row.offerCreateDate) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundHistoryList($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseInboundHistory', 'inboundHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm Inbound Items to self storage",
      "width": "80%",
      "visible": _vm.selfConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.selfConfirmVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "selfConfirm",
    attrs: {
      "model": _vm.selfConfirm,
      "label-width": "220px",
      "rules": _vm.inboundFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.productName),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "productName", $$v)
      },
      expression: "selfConfirm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.company),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "company", $$v)
      },
      expression: "selfConfirm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.price),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "price", $$v)
      },
      expression: "selfConfirm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.num),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "num", $$v)
      },
      expression: "selfConfirm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "leftNum", $$v)
      },
      expression: "selfConfirm.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "quantity", $$v)
      },
      expression: "selfConfirm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "warehouse", $$v)
      },
      expression: "selfConfirm.warehouse"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selfConfirmVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleConfirmInbound($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Confirm Inbound Items to shared warehouse",
      "width": "80%",
      "visible": _vm.warehouseConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseConfirmVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseConfirm",
    attrs: {
      "model": _vm.warehouseConfirm,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.productName),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "productName", $$v)
      },
      expression: "warehouseConfirm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.company),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "company", $$v)
      },
      expression: "warehouseConfirm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.price),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "price", $$v)
      },
      expression: "warehouseConfirm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.num),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "num", $$v)
      },
      expression: "warehouseConfirm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "leftNum", $$v)
      },
      expression: "warehouseConfirm.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "warehouse", $$v)
      },
      expression: "warehouseConfirm.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('p', [_vm._v("Import tracking number as\n                "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.textImportVisible = true
      }
    }
  }, [_vm._v("Text")]), _vm._v("\n                or\n                "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelImportVisible = true
      }
    }
  }, [_vm._v("Excel")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Staus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status"
    },
    on: {
      "change": _vm.changeTrackingFilterStatus
    },
    model: {
      value: (_vm.warehouseConfirm.trackingStatus),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "trackingStatus", $$v)
      },
      expression: "warehouseConfirm.trackingStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": "All"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Claimed",
      "value": "Claimed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Matched",
      "value": "Matched"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Unmatched",
      "value": "Unmatched"
    }
  })], 1), _vm._v(" "), (_vm.warehouseConfirm.unClaimedList.length > 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkConfirm($event)
      }
    }
  }, [_vm._v("Bulk Confirm")]) : _vm._e(), _vm._v(" "), (_vm.warehouseConfirm.unClaimedList.length > 0 || _vm.warehouseConfirm.unMatchedList.length > 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkRemoveSelected($event)
      }
    }
  }, [_vm._v("Bulk Remove Seleted")]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseConfirm.trackingNumbersPage,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.inboundDetailId) ? _c('span', [_vm._v(_vm._s(scope.row.inboundDetailId))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.confirmed) ? _c('div', [(scope.row.matched) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              return _vm.claim(scope.row)
            }
          }
        }, [_vm._v("Claim\n                                    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row)
            }
          }
        }, [_vm._v("Remove\n                                    ")])], 1) : _c('div', [_vm._v("\n                                    claimed\n                                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.warehouseConfirm.currentPage,
      "page-size": 100,
      "total": _vm.warehouseConfirm.total
    },
    on: {
      "current-change": _vm.changeImportTrackingPage
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseConfirmVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Import tracking number from text",
      "width": "80%",
      "visible": _vm.textImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.textImportVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.warehouseConfirm,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "10",
      "placeholder": _vm.placeholder,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("The tracking number import of text needs to contain tracking Numbers, multiple records must be separated by newline.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.textImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importFromText($event)
      }
    }
  }, [_vm._v("Import")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Import tracking number from excel",
      "width": "80%",
      "visible": _vm.excelImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.excelImportVisible = $event
      }
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "on-progress": _vm.preview,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "name": "filename",
      "drag": "",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "data": _vm.uploadData,
      "limit": 1,
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only allowed .xls,.xlsx files, please follow the columns format with trackingNum. include the header.")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cancel Inbound",
      "width": "80%",
      "visible": _vm.cancelInboundVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cancelInboundVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.cancel,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cancel Number"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.cancel.cancelNum),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "cancelNum", $$v)
      },
      expression: "cancel.cancelNum"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancelInboundVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelInbound($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "UnClaimed Tracking#",
      "width": "80%",
      "visible": _vm.unClaimedTrackingVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.unClaimedTrackingVisiable = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "15"
    },
    model: {
      value: (_vm.unClaimedTracking),
      callback: function($$v) {
        _vm.unClaimedTracking = $$v
      },
      expression: "unClaimedTracking"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.unClaimedTrackingVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0065915c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nurse/Inbound.vue
// module id = 766
// module chunks = 1